/* eslint-disable import/prefer-default-export */
const getEnv = (k) => window._env_?.[k] ?? process.env[k];

export const updateRecordRole = async ({ caseId, recordRole }) => {
  window.dispatchEvent(new Event('api-activity'));
  const url = new URL(`${getEnv('REACT_APP_AGENTIC_API_BASE_URL')}/status_update`);
  url.searchParams.append('code', getEnv('REACT_APP_AGENTIC_API_CODE'));
  url.searchParams.append('record_role', recordRole);
  url.searchParams.append('case_id', caseId);

  const res = await fetch(url.toString(), { method: 'PATCH' });
  if (!res.ok) throw new Error('Failed to update record role');
  return res.json();
};
